module.exports = __webpack_public_path__ + "static/media/background_footer.20a99bd1.png";